import api from '../../../helpers/api_helper';

export type DeviceStatus =
  | 'all'
  | 'active'
  | 'no_active_device'
  | 'no_device_record';

export interface PlayerAppStatusRecord {
  id: number;
  first_name: string;
  last_name: string;
  mobile_number: string;
  app_id: string;
  app_name: string;
  device_status: Exclude<DeviceStatus, 'all'>;
  last_device_seen: string | null;
  last_login: string | null;
  has_bet_history: boolean;
}

export interface PlayerAppStatusResponse {
  success: boolean;
  total_count: number;
  page: number;
  page_size: number;
  results: PlayerAppStatusRecord[];
}

export interface PlayerAppStatusQuery {
  page: number;
  page_size: number;
  search?: string;
  device_status?: DeviceStatus;
  app_id?: string;
}

export const fetchPlayerAppStatus = async (
  query: PlayerAppStatusQuery
): Promise<PlayerAppStatusResponse> => {
  const params = new URLSearchParams();

  params.set('page', String(query.page));
  params.set('page_size', String(query.page_size));
  params.set('device_status', query.device_status || 'all');

  if (query.search?.trim()) {
    params.set('search', query.search.trim());
  }

  if (query.app_id?.trim()) {
    params.set('app_id', query.app_id.trim());
  }

  const response = await api.get(
    `/players/app-status/?${params.toString()}`
  );

  return response.data;
};
